import React from "react";
import { motion } from "framer-motion";
import { Phone, Mail, MessageCircle, MapPin, Sparkles } from "lucide-react";
import { contacts } from "../constants/contacts";

const UnderConstruction = () => {
  return (
    <div className="relative min-h-[calc(100vh-140px)] bg-gradient-to-b from-slate-50 via-blue-50/30 to-amber-50/20 text-slate-800 flex items-center justify-center p-4 sm:p-6 lg:p-8 font-sans overflow-hidden">
      {/* Soft Ambient Background Glows */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-96 h-96 bg-blue-200/40 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-10 right-1/4 w-80 h-80 bg-amber-200/30 rounded-full blur-3xl pointer-events-none"></div>

      {/* Clean Glassmorphic Card */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="relative z-10 max-w-xl w-full bg-white/95 backdrop-blur-md border border-slate-200/80 rounded-3xl p-6 sm:p-10 shadow-xl shadow-slate-200/70 text-center"
      >
        {/* Under Construction Hero Image */}
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="relative w-44 h-44 sm:w-56 sm:h-56 mx-auto mb-4 flex items-center justify-center"
        >
          <img
            src="/assets/images/under_construction.png"
            alt="Under Construction"
            className="w-full h-full object-contain drop-shadow-md"
          />
        </motion.div>

        {/* Status Pill Badge */}
        <div className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-amber-50 border border-amber-200 text-amber-800 text-xs font-bold tracking-wide mb-4">
          <Sparkles className="w-3.5 h-3.5 text-amber-600" />
          <span>Website is Under Construction</span>
        </div>

        {/* Main Headline */}
        <h1 className="text-2xl sm:text-4xl font-extrabold text-slate-900 tracking-tight mb-3">
          We'll Be Back Soon!
        </h1>

        {/* Simple Description */}
        <p className="text-slate-600 text-sm sm:text-base max-w-md mx-auto mb-8 font-medium leading-relaxed">
          Dee Novo School is currently upgrading our website to serve you
          better. Thank you for your patience!
        </p>

        {/* Simple & Attractive Contact Action Buttons */}
        <div className="flex flex-wrap items-center justify-center gap-3 mb-8">
          {/* Call Button */}
          <a
            href={`tel:${contacts.mobile1}`}
            className="px-4 py-2.5 rounded-xl bg-primary hover:bg-primaryDark text-white font-bold text-xs sm:text-sm flex items-center gap-2 shadow-xs transition-colors"
          >
            <Phone className="w-4 h-4" />
            <span>Call Us</span>
          </a>

          {/* WhatsApp Button */}
          <a
            href={`https://wa.me/${contacts.whatsApp}`}
            target="_blank"
            rel="noreferrer"
            className="px-4 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs sm:text-sm flex items-center gap-2 shadow-xs transition-colors"
          >
            <MessageCircle className="w-4 h-4" />
            <span>WhatsApp</span>
          </a>

          {/* Email Button */}
          <a
            href={`mailto:${contacts.email}`}
            className="px-4 py-2.5 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-800 font-bold text-xs sm:text-sm flex items-center gap-2 border border-slate-200 transition-colors"
          >
            <Mail className="w-4 h-4 text-slate-600" />
            <span>Email</span>
          </a>
        </div>

        {/* Minimal Footer Address Info */}
        <div className="pt-5 border-t border-slate-100 flex items-center justify-center gap-1.5 text-xs text-slate-500 font-medium">
          <MapPin className="w-3.5 h-3.5 text-slate-400 shrink-0" />
          <span>Dumka, Jharkhand • Best boarding school of the year</span>
        </div>
      </motion.div>
    </div>
  );
};

export default UnderConstruction;
